import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bq2ct7tp: FaireBrandEntity = {
  token: "b_bq2ct7tp",
  type: "brand",
  name: "Hounds and Honeys",
  avatarUrl:
    "https://cdn.faire.com/fastly/6c2660094fe7f7773ce2856c1c387d0285f46df4c2299bc9a043057aeb78f1df.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ec0f7576a65b10d1a3536e25d4f327ee3dcd2abf92305ebb8c9f28160b676919.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6c2660094fe7f7773ce2856c1c387d0285f46df4c2299bc9a043057aeb78f1df.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ec0f7576a65b10d1a3536e25d4f327ee3dcd2abf92305ebb8c9f28160b676919.jpeg",
  location: "MN, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 15,
  isInsider: true,
  description:
    "Hounds and Honeys was started while I was on maternity leave with my daughter.  I soon created a vision of providing small batch, handmade, affordable baby goods.\nAll my items are handmade by myself and my mom.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:27.459Z",
    importedBy: "entity-db-cli",
  },
};
